import { render, staticRenderFns } from "./addFaceDatabaseVant.vue?vue&type=template&id=3ebe5849&scoped=true&"
import script from "./addFaceDatabaseVant.vue?vue&type=script&lang=js&"
export * from "./addFaceDatabaseVant.vue?vue&type=script&lang=js&"
import style0 from "./addFaceDatabaseVant.vue?vue&type=style&index=0&id=3ebe5849&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebe5849",
  null
  
)

export default component.exports